export enum PropertyUnitStatus {
  available_sale = 'available_sale',
  reserved = 'reserved',
  sold = 'sold',
  hidden = 'hidden',
}

export enum PropertyUnitView {
  uploadExcel,
  manualEntry,
  addUnitEntry,
}

export enum PropertyDetailsViewTabs {
  propertyDetails = '/property-details',
  unitsInfo = '/units-information',
  investorsDetails = '/investors-details',
  propertyOrders = '/orders',
}

export enum AnnouncementCategoryType {
  general = 'General',
  dividend = 'Dividend',
  financialStatement = 'Financial Statement',
}
